import { InstagramLogo, LinkedinLogo, YoutubeLogo, XLogo, Lock } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export const Footer = () => {
  const socials = [InstagramLogo, LinkedinLogo, YoutubeLogo, XLogo];
  return (
    <footer className="border-t border-brand-line bg-brand-surface2/40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <p className="font-serif text-3xl text-brand-text">
              TonyBrand<span className="text-brand-gold">29</span>
            </p>
            <p className="text-brand-dim mt-4 max-w-sm leading-relaxed">
              Your doctor for health, wealth mindset and progressively
              productive relationships. Whole-person coaching for a life that works.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="overline mb-4">Explore</p>
            <ul className="space-y-3 text-brand-dim">
              {["Pillars", "Approach", "Ebooks", "Journal"].map((l) => (
                <li key={l}>
                  <button
                    data-testid={`footer-link-${l.toLowerCase()}`}
                    onClick={() =>
                      document
                        .querySelector(`#${l === "Approach" ? "manifesto" : l.toLowerCase()}`)
                        ?.scrollIntoView({ behavior: "smooth" })
                    }
                    className="hover:text-brand-gold transition-colors"
                  >
                    {l}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="overline mb-4">Follow along</p>
            <div className="flex gap-3">
              {socials.map((Icon, i) => (
                <a
                  key={i}
                  href="#top"
                  data-testid={`footer-social-${i}`}
                  className="rounded-full border border-brand-line p-3 text-brand-dim hover:text-brand-gold hover:border-brand-gold transition-colors"
                >
                  <Icon size={20} />
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="hairline mt-14 mb-6" />
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 text-sm text-brand-dim">
          <p>© {new Date().getFullYear()} TonyBrand29. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <p>Whole-person coaching · Not a substitute for medical care.</p>
            <Link
              to="/admin"
              data-testid="footer-admin-link"
              className="inline-flex items-center gap-1.5 text-brand-dim/80 hover:text-brand-gold transition-colors"
            >
              <Lock size={14} weight="fill" /> Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
